module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modify-third-party"
  }, [_c('id_validate', {
    attrs: {
      "v_type": _vm.type,
      "switch_enabled": false,
      "btn_text": _vm.btnText,
      "request": _vm.request
    },
    on: {
      "next": _vm.next,
      "errorResult": _vm.errorResult
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7f573a1c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/validation/other/modify_third_party.vue
// module id = zazj
// module chunks = 16